import React, { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import moment from 'moment'
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md'

var ts = require('@mapbox/timespace')

export function TimeSlotsSection({ freeTimes, setFreeTimes, colorObj, values, handleTimeChange, pack }) {
  const AMTimes = freeTimes?.filter((el) => el.hour < 12)

  const PMTimes = freeTimes?.filter((el) => el.hour >= 12)

  const AMMaxPage = Math.ceil(AMTimes?.length / 8) - 1
  const PMMaxPage = Math.ceil(PMTimes?.length / 8) - 1

  const [AMCurrentPage, setAMCurrentPage] = useState(0)
  const [PMCurrentPage, setPMCurrentPage] = useState(0)

  return (
    <TimeSlots active={!!freeTimes}>
      <Row1>
        <Back
          onClick={() => {
            setFreeTimes(null)
            // setValues({ ...values, date: null, time: null, uDate: null })
          }}
          active={!!freeTimes}
          color={colorObj.text}
        >
          <LeftArrow />
          Hide
        </Back>
        <DateText active={!!freeTimes}>
          {new moment.tz(
            values.date,
            ts
              .getFuzzyLocalTimeFromPoint(values.uDate * 1000, [
                pack.photographer.location.longitude,
                pack.photographer.location.latitude,
              ])
              .tz(),
          ).format('MMM Do YYYY, z')}
        </DateText>
      </Row1>
      {!!freeTimes ? (
        freeTimes.length === 0 ? (
          'Not available for this package'
        ) : (
          <TimesSecton>
            <SubHedaer>
              AM
              <div>
                <LeftArrow
                  disabled={AMCurrentPage === 0}
                  onClick={() => {
                    if (AMCurrentPage !== 0) {
                      setAMCurrentPage(AMCurrentPage - 1)
                    }
                  }}
                />
                <RightArrow
                  disabled={AMCurrentPage === AMMaxPage}
                  onClick={() => {
                    if (AMCurrentPage !== AMMaxPage) {
                      setAMCurrentPage(AMCurrentPage + 1)
                    }
                  }}
                />
              </div>
            </SubHedaer>
            <TimesWrapper background={colorObj.accent2} color={colorObj.background}>
              {AMTimes.slice(AMCurrentPage * 8, AMCurrentPage * 8 + 8).map((el, i) => {
                let selected = false
                if (values.time && el.hour === values.time.hour && el.minute === values.time.minute) {
                  selected = true
                }
                return (
                  <TimeButton
                    key={i}
                    onClick={() => handleTimeChange(el)}
                    active={selected}
                    background={colorObj.accent3}
                    color={colorObj.text}
                  >
                    {el.hour > 12 ? el.hour - 12 : el.hour}:{el.minute === 0 ? '00' : el.minute}
                    {el.hour >= 12 ? 'PM' : 'AM'}
                  </TimeButton>
                )
              })}
            </TimesWrapper>
            <SubHedaer>
              PM{' '}
              <div>
                <LeftArrow
                  disabled={PMCurrentPage === 0}
                  onClick={() => {
                    if (PMCurrentPage !== 0) {
                      setPMCurrentPage(PMCurrentPage - 1)
                    }
                  }}
                />
                <RightArrow
                  disabled={PMCurrentPage === PMMaxPage}
                  onClick={() => {
                    if (PMCurrentPage !== PMMaxPage) {
                      setPMCurrentPage(PMCurrentPage + 1)
                    }
                  }}
                />
              </div>
            </SubHedaer>
            <TimesWrapper background={colorObj.accent2} color={colorObj.background}>
              {PMTimes.slice(PMCurrentPage * 8, PMCurrentPage * 8 + 8).map((el, i) => {
                let selected = false
                if (values.time && el.hour === values.time.hour && el.minute === values.time.minute) {
                  selected = true
                }
                return (
                  <TimeButton
                    key={i}
                    onClick={() => handleTimeChange(el)}
                    active={selected}
                    background={colorObj.accent3}
                    color={colorObj.text}
                  >
                    {el.hour > 12 ? el.hour - 12 : el.hour}:{el.minute === 0 ? '00' : el.minute}
                    {el.hour >= 12 ? 'PM' : 'AM'}
                  </TimeButton>
                )
              })}
            </TimesWrapper>
          </TimesSecton>
        )
      ) : null}
    </TimeSlots>
  )
}

const TimesSecton = styled.div`
  display: flex;
  flex-direction: column;
`

const SubHedaer = styled.label`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 14px;
  font-weight: 700;
`

const Row1 = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0 0 0;
`

const Back = styled.div`
  display: ${(props) => (props.active ? 'flex' : 'none')};
  align-items: center;
  color: ${(props) => props.color};
  font-size: 14px;
  cursor: pointer;
  margin: 0 0 1em 0;
  ${(props) =>
    props.page === 1 &&
    css`
      margin: 0;
    `}
`

const LeftArrow = styled(MdKeyboardArrowLeft)`
  cursor: pointer;
  font-family: inherit;
  color: ${(props) => (props.disabled ? 'grey' : 'inherit')};
  margin: 2px 2px 0 -3px;
`

const RightArrow = styled(MdKeyboardArrowRight)`
  cursor: pointer;
  font-family: inherit;
  color: ${(props) => (props.disabled ? 'grey' : 'inherit')};
  margin: 2px 2px 0 5px;
`

const TimeSlots = styled.div`
  display: flex;
  flex-direction: column;
  min-width: ${(props) => (props.active ? '345px' : 'auto')};
  padding: 0 0 0 20px;
  margin: 10px 0 0 0;
  @media (max-width: 1520px) {
    width: 100%;
  }
`

const TimesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin: 10px 0;
  max-height: 500px;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.color};
    border: none;
  }
  background: ${(props) => (props.background ? props.background : 'transparent')};
  @media (max-width: 850px) {
    margin: 0;
    padding: 0;
    max-height: 450px;
  }
`

const TimeButton = styled.button`
  border: ${(props) => (props.active ? 'none' : props.color ? `1px solid ${props.color}` : 'none')};
  color: ${(props) => props.color};
  background: ${(props) => (props.active ? props.background : 'transparent')};
  font-size: 12px;
  font-weight: 400;
  padding: 5px;
  margin: 5px;
  width: 70px;
  border-radius: 3px;
  :hover {
    background: ${(props) => props.background};
  }
`

const DateText = styled.div`
  display: ${(props) => (props.active ? 'flex' : 'none')};
  align-items: center;
  margin: 0 0 1em 0;
  font-size: 14px;
`
